import { useState, useEffect } from "react";
import { subscribeToLogos } from "../services/logoService";
import { useAuth } from "../context/AuthContext";

export function useCompanyLogos() {
  const [allCompanyLogos, setAllCompanyLogos] = useState([]);
  const [companyLogos, setCompanyLogos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { currentUser } = useAuth();

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribeToLogos((data, err) => {
      if (err) {
        setError("Failed to load company logos.");
        setLoading(false);
        return;
      }
      setAllCompanyLogos(data);
      
      // Filter companies to only include those assigned to the current user,
      // or those that have no assignments (so they don't get lost).
      const filtered = data.filter(logo => 
        !logo.assignedUsers || 
        logo.assignedUsers.length === 0 || 
        logo.assignedUsers.includes(currentUser?.uid)
      );
      setCompanyLogos(filtered);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return {
    companyLogos,
    allCompanyLogos,
    loading,
    error
  };
}
